import { useLocalStore } from 'mobx-react'
import { transcribe as transcribeModal, common, user, meeting } from '@/models'
import { TranscribeStatus } from '../../component/ControlBar/PC/TranscribeBtn'
import { useIntl } from 'umi'
import { message } from '@/components'
import { ROLE } from '@/types/meeting' // 增加导入

export enum TranscribeStatusWs {
  unknow = -1, // 未知
  SCHEDULING = 0, // 转录调度中
  ON = 1, //转开启
  OFF = 2, //转录关闭
  FAILED = 3, //转录开启失败
}
export interface transcriptionData {
  timestamp: number
  channelId: number
  transcriptionStatus: TranscribeStatusWs // 2 停止,
  transcriptionPageUrl: string
}
export default function useTranscribeChange() {
  const { formatMessage } = useIntl()
  const { transcribe } = useLocalStore(() => {
    return {
      transcribe: transcribeModal,
    }
  })

  const shouldHideMessage = common?.isGroupInterview && meeting?.getMemberByYxuid(user?.yxuid!)?.role === ROLE.GUEST

  const change = async (body: transcriptionData) => {
    if (body.transcriptionStatus === TranscribeStatusWs.OFF) {
      if (!shouldHideMessage) {
        message.info({
          content: formatMessage({ id: 'offTranscribe' }),
          noIcon: true,
        })
      }
      transcribe.setTranscribeStatus(TranscribeStatus.pauseTranscribe)
    } else if ([TranscribeStatusWs.ON].includes(body.transcriptionStatus)) {
      if (!shouldHideMessage) {
        message.info({
          content: formatMessage({ id: 'openTranscribe' }),
          noIcon: true,
        })
      }
      transcribe.setTranscribeStatus(TranscribeStatus.intranscribe)
    }
  }

  return change
}
